module.exports = __webpack_public_path__ + "static/Refinery_logo1-0647b5f55049b4adbcb09fd2025ea48d.png";